const string = {
  _app: "سامانه ثبت سفارش سرنخ",
  app_name: "ثبت سفارش سرنخ",
  currency: "تومان",
  submit_order_system: "سامانه ثبت سفارش",

  // titles
  discounted: "تخفیف دار",
  all: "همه",
  call_ways: "راههای ارتباطی",
  wholesaler_code: "کد بنکداری",
  share: "اشتراک گذاری",
  profile: "پروفایل",
  logout_from_account: "خروج از حساب",
  about_us: "درباره ما",
  contact_us: "ارتباط با ما",
  mobile: "شماره موبایل",
  register: "ثبت نام",
  address: "آدرس",
  province: "استان",
  city: "شهر",
  phone: "تلفن ثابت",
  full_name: "نام و نام‌خانوادگی",
  shop_name: "نام فروشگاه",
  products: "محصولات",
  category: "گروه محصولات",
  cart: "سبد خرید",
  orders: "سفارشات",
  order_details: "جزییات سفارش",
  factor: "فاکتور",
  number: "شماره",
  add_custom_attrs_descriptions: "توضیحات مربوط به ویژگی‌های دلخواه",

  // placeholders
  insert_title_search: "عنوان مورد جستجو را وارد کنید",
  pick: "انتخاب کنید",
  insert_description: "توضیحات را وارد کنید",
  insert_mobile: "شماره موبایل خود را وارد کنید",
  select_province: "استان را انتخاب کنید",
  select_city: "شهر را انتخاب کنید",
  search: "جستجو کنید",
  insert_address: "جزییات آدرس را وارد کنید",
  insert_name: "نام خود را وارد کنید",
  insert_phone: "شماره تلفن را وارد کنید",
  insert_full_name: "نام خود را وارد کنید",
  insert_shop_name: "نام فروشگاه را وارد کنید",
  insert_cart_item_description:
    "توضیحات مربوط به ویژگی دلخواه را در بخش توضیحات وارد کنید",

  // button titles
  upgrade: "بروز رسانی",
  apply_to_cart: "اعمال به سبد خرید",
  login: "ورود",
  logout: "خروج",
  remove_cart: "حذف سبد خرید",
  final_submit_cart: "تایید نهایی خرید",
  remove_cart_item: "حذف محصول",
  cancel: "انصراف",
  confirm: "تایید",
  submit_order: "ثبت خرید",
  camera: "دوربین",
  gallery: "گالری",
  delete_avatar: "حذف تصویر",
  send_code_again: "ارسال مجدد کد",
  return: "بازگشت",
  submit_info: "ثبت اطلاعات",
  copy_code: "کپی کردن کد",
  view_cart: "مشاهده سبد خرید",
  complete_the_purchase: "نهایی کردن خرید",
  bazar: "بازار",
  play: "فروشگاه گوگل",
  myket: "مایکت",
  direct: "دانلود مستقیم اپلیکیشن",

  // toast titles
  successTitle: "انجام شد",
  errorTitle: "خطا",
  warningTitle: "هشدار",
  infoTitle: "توجه",

  // alerts messages
  company_is_different:
    "در هر بار خرید، تنها از یک فروشگاه می‌توانید خرید انجام دهید",
  server_error: "خطا در ارتباط با سرور",
  _404_error: "صفحه مورد نظر یافت نشد",
  connection_error: "لطفا از اتصال دستگاه خود به اینترنت مطمئن شوید",
  do_again: "تلاش مجدد",
  retry: "مشکلی در ارتباط با سرور رخ داده است. لطفا مجددا تلاش نمایید",
  are_you_sure_to_logout: "آیا برای خروج از حساب کاربری اطمینان دارید؟",
  are_you_sure_to_remove_cart: "آیا برای خروج از حساب کاربری اطمینان دارید؟",
  mobile_is_required: "شماره موبایل الزامی است",
  invalid_mobile: "شماره وارد شده معتبر نمی باشد",
  fill_security_code: "کد تایید را وارد کنید",
  invalid_security_code: "کد تایید نا معتبر است",
  fill_input: "لطفا این قسمت را پر کنید",
  please_pick_province: "لطفا استان را انتخاب کنید",
  you_want_remove_cart: "شما می‌خواهید سبد خرید را حذف کنید",
  you_want_remove_cart_item: "شما می‌خواهید این محصول را از سبد خرید حذف کنید",
  submit_cart_is_not_editable:
    "در صورت تایید نهایی، سفارش شما ثبت شده و قابل ویرایش نمی‌باشد.",
  are_you_sure: "آیا اطمینان دارید؟",
  new_version_of_app_is_available: "نسخه جدید اپلیکیشن در دسترس است.",
  this_version_of_app_unusable: "نسخه جاری اپلیکیشن قابل استفاده نیست.",
  please_update_the_app:
    "لطفا برای استفاده از امکانات کامل برنامه، آن را به روزرسانی نمایید",

  // others
  support_phone: "09138717870",
  developed_by: "توسعه توسط",
  itsa: "فناوری اطلاعات آیتیسا",

  // infos
  code_was_send_to: (number: string): string =>
    `کد تایید به شماره ${number} فرستاده شد`,
  until_code_resent: (time: string) => `${time} تا ارسال مجدد کد`,
  did_not_receive_code: "هنوز کدی دریافت نکرده اید؟",

  not_any_item_to_show: "موردی برای نمایش وجود ندارد",

  products_in_your_cart: "محصول در سبد خرید شما ",
};

export default string;
